import { AxiosResponse } from 'axios'
import { UpdateBody } from 'types/common'
import { api } from 'API'
import { ITextContent } from 'interfaces/textContent'

export async function updateTextContentById(id: string, updateBody: UpdateBody<ITextContent>): Promise<void> {
  await api.patch(`/text-contents/${id}`, updateBody)
}

export async function deleteTextContentById(id: string): Promise<void> {
  await api.delete(`/text-contents/${id}`)
}

export async function createTextContent(updateBody: Partial<ITextContent>): Promise<ITextContent> {
  const response: AxiosResponse = await api.post(`/text-contents`, updateBody)
  return response?.data
}

export async function upsertMedia(id: string, mediaIds: number[]): Promise<void> {
  await api.patch(`/text-contents/${id}/upsert-media`, mediaIds)
}
